<template>
  <div class="grid">
    <div class="col-12">
      <EventsTable></EventsTable>
    </div>
  </div>
</template>

<script>
import EventsTable from "@/components/tables/EventsTable";
export default {
  name: "Events",
  components: {EventsTable}
}
</script>

<style scoped>

</style>